// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"dd8ce0dd","667":"ff1091fa"}[chunkId] + ".chunk.js";
};